import {
  Globe,
  Sparkles,
  FileEdit,
  Navigation,
  Keyboard,
  CheckCircle2,
  Shield,
  Lock,
  User,
  CreditCard,
  Puzzle,
  Bell,
  MessageSquare,
  Bot,
  Plug,
  Network,
} from 'lucide-react';

/* ── Static data ─────────────────────────────────────────────────────────────── */
export const TABS = [
  { id: 'general',      Icon: Globe,         labelKey: 'settings.tabGeneral' },
  { id: 'appearance',   Icon: Sparkles,       labelKey: 'settings.tabAppearance' },
  { id: 'editor',       Icon: FileEdit,       labelKey: 'settings.tabEditor' },
  { id: 'requests',     Icon: Navigation,     labelKey: 'settings.tabRequests' },
  { id: 'proxy',        Icon: Network,        labelKey: 'settings.tabProxy' },
  { id: 'notifications', Icon: Bell,          labelKey: 'settings.tabNotifications' },
  { id: 'chat',         Icon: MessageSquare,  labelKey: 'settings.tabChat' },
  { id: 'aiChat',       Icon: Bot,            labelKey: 'settings.tabAiChat' },
  { id: 'account',      Icon: User,           labelKey: 'settings.tabAccount',   authOnly: true },
  { id: 'billing',      Icon: CreditCard,     labelKey: 'settings.tabBilling',   authOnly: true },
  { id: 'keyboard',     Icon: Keyboard,       labelKey: 'settings.tabKeyboard' },
  { id: 'certificates', Icon: Lock,           labelKey: 'settings.tabCertificates' },
  { id: 'mcp',          Icon: Plug,          labelKey: 'settings.tabMcp' },
  // Not authOnly: Phase 9 local encryption is a device-local feature; the
  // account-bound rows inside the tab gate themselves on auth.
  { id: 'privacy',      Icon: Shield,         labelKey: 'settings.tabPrivacy' },
  { id: 'extensions',   Icon: Puzzle,         labelKey: 'settings.tabExtensions' },
  { id: 'about',        Icon: CheckCircle2,   labelKey: 'settings.tabAbout' },
];

/* Searchable terms per tab for the sidebar filter — the tab's label and
   subtitle are always indexed via i18n; these extras catch the row-level
   things people actually type ("invoices", "2FA", "proxy"). The first hit is
   shown under the tab name in the result list. */
export const SETTINGS_SEARCH_KEYWORDS = {
  general:      ['Language', 'Region', 'Time format', 'Startup', 'Updates'],
  appearance:   ['Theme', 'Dark mode', 'Accent color', 'Density', 'Font size', 'Motion', 'Effects'],
  editor:       ['Code editor', 'Word wrap', 'Font', 'Response viewer'],
  requests:     ['Timeout', 'Redirects', 'SSL verification', 'User agent', 'Cookies'],
  proxy:        ['Proxy', 'HTTP proxy', 'SOCKS5', 'System proxy', 'Bypass', 'No proxy', 'Test connection'],
  notifications: ['Desktop notifications', 'Sound', 'Chat notifications'],
  chat:         ['Link previews', 'Read receipts'],
  aiChat:       ['AI', 'API key', 'Apiboo', 'Anthropic', 'OpenAI', 'Gemini', 'Claude', 'GPT', 'Model', 'Assistant', 'Bring your own key'],
  account:      ['Profile', 'Password', 'Email', 'Two-factor', '2FA', 'Passkeys', 'Delete account', 'CLI token', 'GitHub', 'Avatar'],
  billing:      ['Plan', 'Subscription', 'Invoices', 'Payment', 'AI tokens', 'Upgrade', 'Withdraw from contract', 'Vertrag widerrufen'],
  keyboard:     ['Shortcuts', 'Keybindings', 'Hotkeys'],
  certificates: ['Client certificates', 'CA certificates', 'SSL verification', 'TLS'],
  mcp:          ['MCP', 'Model Context Protocol', 'Claude', 'Claude Code', 'Claude Desktop', 'Cursor', 'Agent', 'Token', 'Port', 'Server'],
  privacy:      ['Data export', 'Local encryption', 'Sync encryption', 'Usage data', 'Cloud copy'],
  extensions:   ['Marketplace', 'Permissions', 'Install', 'Uninstall'],
  about:        ['Version', 'Licenses', 'Website'],
};

export const TAB_SUBTITLE = {
  general:      'settings.subtitleGeneral',
  appearance:   'settings.subtitleAppearance',
  editor:       'settings.subtitleEditor',
  requests:     'settings.subtitleRequests',
  proxy:        'settings.subtitleProxy',
  chat:         'settings.subtitleChat',
  aiChat:       'settings.subtitleAiChat',
  account:      'settings.subtitleAccount',
  billing:      'settings.subtitleBilling',
  keyboard:     'settings.subtitleKeyboard',
  certificates: 'settings.subtitleCertificates',
  mcp:          'settings.subtitleMcp',
  privacy:      'settings.subtitlePrivacy',
  extensions:   'settings.subtitleExtensions',
  about:        'settings.subtitleAbout',
};
